// extracted by mini-css-extract-plugin
export default {"container":"BlogPostMenu_container_VaL21","item":"BlogPostMenu_item_Of1VM","itemDisabled":"BlogPostMenu_itemDisabled_drjAN","icon":"BlogPostMenu_icon_lfRMx"};